import { Component, OnInit, ViewChild, OnDestroy, AfterContentChecked } from '@angular/core';
import { Router, RouterLinkActive, NavigationStart, NavigationEnd, Event as NavigationEvent } from '@angular/router';

@Component({
	selector: 'app-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.scss'],
	standalone: false ,  // NOSONAR
})
export class ToolbarComponent implements OnInit, OnDestroy, AfterContentChecked {

	@ViewChild('board') private board: RouterLinkActive; // NOSONAR

	enableHomeGrey = false;
	enableHomeRed = true;
	event: any;
	activeBoard: boolean = false;
	activeSubBoard: boolean = false;
	highlightTask = false;
	isAdmin: boolean;

	ngAfterContentChecked(): void { 


		
		const userData = sessionStorage?.getItem('FGA');
		let roles:any
		if (userData) {
			roles = JSON.parse(userData)?.roles
			const role = roles?.filter(r => r.displayName == 'Task Manager Admin')  // NOSONAR
			this.isAdmin = role && role.length > 0 ? true : false;
		}
		// board home icon css
		if (this.board?.isActive || this.router.url == '/') {  // NOSONAR
			this.enableHomeRed = true;
			this.enableHomeGrey = false;
			this.activeBoard = true;
		}
		else if (this.router.url == '/newtask' || this.router.url == '/createmonthlytask' || this.router.url == '/createonetime' || this.router.url == '/createfromtemplate' || this.router.url == '/newcontingency' || this.router.url == '/createcontingency' || this.router.url == '/weeklytask' || this.router.url == '/createperiod' || this.router.url == '/editperiod' || this.router.url == '/editonetime' || this.router.url == '/mytasks') {  // NOSONAR
			this.activeBoard = false;
			this.activeSubBoard = true;
			this.enableHomeRed = true;
			this.enableHomeGrey = false;
		}

		else {
			this.activeBoard = false;
			this.activeSubBoard = false;
			this.enableHomeRed = false;
			this.enableHomeGrey = true;
		}

		if (this.router.url == '/task' || this.router.url == '/subtask') { // NOSONAR
			this.highlightTask = true;
		}
		else {
			this.highlightTask = false;
		}

	}

	constructor(private readonly router: Router) {
	}

	ngOnInit(): void { // NOSONAR
		//  do something 
	}

	ngOnDestroy() { // NOSONAR

		this.event.unsubscribe();
	}

}
